import * as api from "../../api/generated-api";
import { Stack, Typography } from "@mui/material";
import React from "react";

export const CompanyAddress = (props: { company: api.Organization }) => {
  const company = props.company;
  return (
    <>
      <Typography variant={"subtitle2"}>Address</Typography>
      {(company.line || company.city || company.state || company.zip) && (
        <Stack>
          <Typography variant={"body1"}>{company.line}</Typography>
          <Typography
            variant={"body1"}
          >{`${company.city}, ${company.state} ${company.zip}`}</Typography>
        </Stack>
      )}
    </>
  );
};
